import { render } from "./DeleteLab.vue?vue&type=template&id=37fa2dd0"
import script from "./DeleteLab.vue?vue&type=script&lang=js"
export * from "./DeleteLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__